import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LangObj } from 'src/app/models';
import { FormService, LanguageService, ValidatorsService } from 'src/app/services';

@Component({
  selector: 'ff-input-lang',
  templateUrl: './ff-input-lang.component.html',
  styleUrls: ['./ff-input-lang.component.css']
})
export class FfInputLangComponent implements OnInit {

  languages: LangObj[] = [];
  subscriptions: Subscription = new Subscription();
  errorMessagesForLang: any;
  validationExceptions: any[] = [{ lang: 'ru' }];
  incomingValue: any;

  @Input() label: string;
  @Input() hint: string;
  @Input() placeHolder: string = 'Введите значение';
  @Input() fieldName: string;
  @Input() fieldId: string = 'input_' + this.formService.makeid(10);
  @Input() fieldType: string = 'text';
  @Input() clearField: boolean = false;
  @Input() validator: ValidatorFn[] = [];
  @Input() errorMessages: any[] = [];
  @Input() required: boolean = false;
  @Input() formControlName: string;
  @Input() readonly: boolean;
  // @Input() validationExceptions: any[] = [];

  @Input() set inputValue(value: any) {

    if (value) {
      this.incomingValue = value;
      this.setInputValueToField(value);

    }
  }

  @Output() changeValue = new EventEmitter();

  form: UntypedFormGroup = this.fb.group({
    currentLang: [null, Validators.required],
    field: [null, this.validator],
    list: this.fb.array([]),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private formService: FormService,
    private validatorService: ValidatorsService,
  ) { }

  ngOnInit(): void {

    this.getLang();
    this.onFieldValueChanges();
    this.setValueToField();
    this.setDefaultValidator();

  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param value 
   */
  private setInputValueToField(value): void {

    if (this.languages) {

      let list: any[] = this.form.get('list').value;

      for (let index = 0; index < list.length; index++) {

        this.form.get(['list', index, 'value']).setValue(value[list[index].lang]);
      }

      this.form.get('field').setValue(value[this.form.get('currentLang').value]);
    }
  }


  /**
   * 
   */
  protected clearingField(): void {

    if (this.clearField) {

      this.form.get('field').setValue(null);

      for (let i = 0; i < this.form.get('list').value.length; i++) {

        this.form.get(['list', i, 'value']).setValue(null);
        this.form.get(['list', i, 'value']).markAsDirty({ onlySelf: true });
      }
    }
  }


  /**
   * 
   */
  private setValueToField(): void {

    this.subscriptions.add(
      this.form.get('currentLang').valueChanges.subscribe((currentLang: string) => {

        let list: any[] = this.form.get('list').value;

        if (!currentLang) return;

        let index = list.findIndex(val => val.lang == currentLang);

        if (index <= -1) return;

        let value: any = this.form.get(['list', index, 'value']).value;

        this.form.controls.field.setValue(value);
      })
    );
  }


  /**
   * 
   */
  private onFieldValueChanges(): void {

    this.subscriptions.add(
      this.form.get('field').valueChanges.subscribe((fieldValue: string) => {

        let currentLang: string = this.form.get('currentLang').value;
        let list: any[] = this.form.get('list').value;

        if (!currentLang) return;

        let index = list.findIndex(val => val.lang == currentLang);

        if (index <= -1) return;

        this.form.get(['list', index, 'value']).setValue(fieldValue);

        //
        for (let i = 0; i < this.languages.length; i++) {

          if (!this.form.get(['list', i, 'value']).value) {

            this.form.get(['list', i, 'value']).markAsDirty({ onlySelf: true });
          }
        }

        this.onOutputData();
      })
    );
  }


  /**
   * 
   * @returns 
   */
  private onOutputData(): any {

    let list: any[] = this.form.get('list').value;

    if (list.length == 0) return;

    let obj = list.reduce(function (result, item) {

      result[item.lang] = item.value;
      return result;
    }, {});

    this.changeValue.emit({
      [this.fieldName]: obj,
      valid: this.form.valid
    });
  }


  /**
   * 
   */
  private getLang(): void {

    this.languages = this.languageService.languagesObj;


    if (this.languages.length > 0) {

      this.form.controls.currentLang.setValue(this.languageService.defaultLanguage);
      this.addLang();

      if (this.incomingValue != null) {
        this.setInputValueToField(this.incomingValue);
      }

    }

    this.subscriptions.add(
      this.languageService.listenerLanguages().subscribe((value: LangObj[]) => {

        this.languages = value;

        this.form.controls.currentLang.setValue(this.languageService.defaultLanguage);
        this.addLang();
        if (this.incomingValue != null) {
          this.setInputValueToField(this.incomingValue);
        }
      })
    );
  }


  /**
   * 
   * @returns FormGroup
   */
  private initLang(lang: string): UntypedFormGroup {

    let valid = this.validationExceptions.find(val => val.lang == lang) ? Validators.required : null;

    return this.fb.group({
      lang: [lang, valid],
      value: [null, valid]
    });
  }


  /**
   * 
   */
  private addLang(): void {

    const control = this.form.controls.list as UntypedFormArray;

    for (let language of this.languages) {

      control.push(this.initLang(language.code2));
    }
  }

  /**
   * 
   */
  private setDefaultValidator(): void {


    this.subscriptions.add(

      this.form.get('field').valueChanges.subscribe((fieldValue: string) => {

        let currentLang: string = this.form.get('currentLang').value;


        if (this.validator.length == 0 && this.required && currentLang == this.validationExceptions[0].lang) {

          this.form.controls.field.setValidators(Validators.required);

        }
        //  else {

        //   // this.form.controls.field.setValidators(this.validator);
        // }

        this.form.controls.field.setValidators(null);

        if (this.errorMessages.length == 0 && this.required) {

          this.errorMessages = [
            {
              type: 'required',
              message: 'MESSAGES.REQUIRED_FIELD',
              options: null
            }
          ]
          this.errorMessagesForLang = [
            {
              type: 'required',
              message: 'MESSAGES.REQUIRED_FIELD_WN',
              options: null
            }
          ]
        }


      })
    );


    // if(this.validator.length == 0 && this.required){

    //   this.form.controls.field.setValidators(Validators.required);
    // }
    // // else {

    // //   this.form.controls.field.setValidators(this.validator);
    // // }


    // if(this.errorMessages.length == 0 && this.required){

    //   this.errorMessages = [
    //     {
    //       type: 'required', 
    //       message: 'MESSAGES.REQUIRED_FIELD',
    //       options: null
    //     }
    //   ]
    // }

    // this.errorMessagesForLang = [
    //   {
    //     type: 'required', 
    //     message: 'MESSAGES.REQUIRED_FIELD_WN',
    //     options: null
    //   }
    // ]


  }

  /**
   * 
   */
  getLangComparison(lang: string): string {

    switch (lang) {

      case 'Русский':
        return 'русском'

      case 'Английский':
        return 'английском'

      case 'Казахский':
        return 'казахском'

    }

  }


  /**
   * 
   * @param field any
   * @param type string
   * @returns boolean
   */
  protected validation(field: any, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
